export const oldApiEnvironment = {
  production: false,
  api: 'https://gutwintest.westeurope.cloudapp.azure.com/gutwin',
  applicationKey: '',
  applicationVersion: '',
  sentryUrl: 'https://b7f6b076f3e44a54b7eb680e6365491d@sentry.io/226835'
};
